import Commons from '../../../../Services/Common/Common';

export const M_PER_NEW_Schema = {
  mapper: {
    search1: {
      SearchType: (context) =>
        Commons.EncryptAES(context.search?.searchType || 'RECENT'),
      WorkDate: (context) =>
        Commons.EncryptAES(
          context.search?.searchType === 'DATE' ? context.search?.startDate : ''
        ),
      DepCd: (context) => Commons.EncryptAES(context.search?.depCd),
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      UserId: (context) => context.userInfo?.userid,
    },
    search2: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      UserId: (context) => context.userInfo?.userid,
    },
    search3: {
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      UserId: (context) => context.userInfo?.userid,
    },
    search4: {
      UserId: (context) => context.userInfo?.userid,
    },
    save1: {
      PmCd: (context) => Commons.EncryptAES(context.pmCd),
      WorkEndDate: (context) => context.workEndDate,
      UserId: (context) => context.userInfo?.userid,
      SmId: (context) => Commons.EncryptAES(context.smId),
    },
    save2: {
      PmCd: (context) => Commons.EncryptAES(context.pmCd),
      DepHeadId: (context) => Commons.EncryptAES(context.currentHead?.headId),
      DepSignPath: (context) => Commons.EncryptAES(''),
    },
  },
};
